import React from "react";
import "./InfoPopup.css";

type Props = {
  onClose: () => void;
};

const InfoPopup = ({ onClose }: Props) => (
  <div className="info-popup-overlay">
    <div className="info-popup-modal">
      <div className="info-popup-content">
        <p className="info-popup-title">
          アップロードされた画像について下記の観点から検閲してください。
        </p>
        <ul className="info-popup-list">
          <li>著作権を侵害する画像</li>
          <li>わいせつな画像</li>
          <li>暴力的な画像</li>
          <li>個人情報を含む画像</li>
          <li>その他、法令に違反する画像</li>
        </ul>
        <button className="info-popup-close-btn" onClick={onClose}>
          閉じる
        </button>
      </div>
    </div>
  </div>
);

export default InfoPopup;
